var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24941)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zm0-23C5.873 0 .5 5.373.5 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.516 6.875c-.884 0-1.743.299-2.42.841a3.67 3.67 0 00-1.03 1.306.625.625 0 001.132.527c.152-.327.386-.623.678-.857a2.626 2.626 0 011.64-.567c1.395 0 2.53 1.065 2.53 2.375 0 1.23-.983 2.247-2.286 2.364a2.827 2.827 0 01-.244.011h-.012a.626.626 0 00-.625.625v2a.626.626 0 001.25 0v-1.433c1.841-.285 3.166-1.769 3.166-3.567 0-1.999-1.695-3.625-3.779-3.625zM11.348 17.5a.625.625 0 111.25 0 .625.625 0 01-1.25 0z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24941"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgHelp.displayName = 'Help';
export default SvgHelp;